import { Category } from "@mui/icons-material";
import { client } from "utils/axios"
import * as yup from "yup";

export async function deleteSupplier(SupplierId) {
  try {
    await client.delete(`supplier/${SupplierId}`);
  } catch (error) {
    console.log(error)
  }

};
export async function getAllSupplier() {
  try {
    const { data } = await client.get("/supplier");
    return data;
  } catch (error) {
    return []
  }

}
export async function getAllCategories() {
  const { data } = await client.get("/category");
  return data;
}
export const validationSchemaSupplier = yup.object({
  nombre: yup
    .string("Ingresa Nombre")
    .required("Campo Requerido"),
  apellidoPaterno: yup
    .string("Ingresa el apellido Paterno")
    .required("Campo Requerido"),
  apellidoMaterno: yup
    .string("Ingresa el apellido Materno"),
  direccion: yup
    .string("Ingresa la Dirección")
    .required("Campo Requerido"),
  rfc: yup
    .string("Ingresa el RFC"),
  codigo: yup
    .string("Ingresa el Código")
    .required("Campo Requerido"),

});
export async function createSupplier(dataInput) {
  console.log(dataInput)
  try {
    let persona = {
      nombre: dataInput.nombre,
      apellidoPaterno: dataInput.apellidoPaterno,
      apellidoMaterno: dataInput.apellidoMaterno,
      direccion: dataInput.direccion,
      rfc: dataInput.rfc
    }
    const { data } = await client.post("personas", persona);

    let supplier = {
      persona: { id: data.id },
      code: dataInput.code,
      phone: dataInput.phone,
      category : dataInput.category
    }
    await client.post("supplier", supplier);

    return true;

  } catch (error) {
    console.log(error)
    return false;
  }

};
export async function modifySupplier(supplier) {
console.log(supplier)
  let persona = {
    apellidoPaterno: supplier.apellidoPaterno,
    apellidoMaterno: supplier.apellidoMaterno,
    nombre: supplier.nombre,
    rfc: supplier.rfc,
    direccion: supplier.direccion,
    id: supplier.persona.id
  }
  console.log(persona)
  try {
    await client.put("personas", persona);
    await client.put("supplier", supplier);
  } catch (error) {

  }

};